import React from 'react';

import TopNavItem from '@components/Nav/TopNav/NavItem';

const MyTINav = () => {
  // TODO FIXME: Needs adjusted for actual content and jump linking
  // Will add to subsequent PRs

  return (
    <nav className="mt-48 border-0 border-b border-t border-solid border-grayscale-beige py-32 [&_+_article]:border-t-0 [&_+_article]:pt-0">
      <ul className="m-0 flex flex-1 list-none flex-col items-center justify-center p-0 sm:flex-row sm:gap-24">
        <TopNavItem as="link" className="before:hidden sm:before:block" href="#">
          Recommended Articles
        </TopNavItem>
        <TopNavItem as="link" className="before:hidden sm:before:block" href="#" showLeftDivider>
          Trending
        </TopNavItem>
        <TopNavItem as="link" className="before:hidden sm:before:block" href="#" showLeftDivider>
          Newsletters
        </TopNavItem>
        <TopNavItem as="link" className="before:hidden sm:before:block" href="#" showLeftDivider>
          Community
        </TopNavItem>
      </ul>
    </nav>
  );
};

export default MyTINav;
